// extracted by mini-css-extract-plugin
export default {"progressIcon":"progress-icon__pQKbcan9","progress":"progress__iYsadTmv"};